import '@/commons';
import Vue from 'vue';
import store from '@/store';
import { onMounted, ref } from '@vue/composition-api';
import { Debug } from '@/shared/utils/helpers';
import vuetify from '@/config/plugins/vuetify';
import Footer from '@/layout/footer';
import Menu from '@/layout/menu';
import { toggles } from '@/observable';
import Carga from '@/layout/carga';
import ZoomScroll from 'vue-zoom-scroll';
import 'intersection-observer';
import Scrollama from 'vue-scrollama';


const carga = Carga;
const footer = Footer;
const menu = Menu;

const Servicios = Vue.extend({
  components: {ZoomScroll, Scrollama},
  setup() {
    // variables
    const cargado = ref(false);
    const contacto = ref(false);
    const currStep = ref('');
    const r1 = ref(false);
    const r2 = ref(false);
    const r3 = ref(false);
    const r4 = ref(false);
    const r5 = ref(false);
    const h = ref(false);
    const table = ref(false);
    const mov = ref(false);
    const pasos = ({ element }: any) => {
      if (element.dataset.stepNo === '2') {
        r1.value = true;
        r2.value = false;
      } else if (element.dataset.stepNo === '3') {
        r1.value = true;
        r2.value = !r2.value;
        h.value = false;
      } else if (element.dataset.stepNo === '4') {
        h.value = true;
        r2.value = true;
        r3.value = false;
      } else if (element.dataset.stepNo === '6') {
        r1.value = true;
        r2.value = true;
        r3.value = true;
        if (r4.value === true) {
          r4.value = !r4.value;
        }
      } else if (element.dataset.stepNo === '8') {
        r1.value = true;
        r2.value = true;
        r3.value = true;
        r4.value = true;
      } else if (element.dataset.stepNo === '1') {
        if (r1.value === true) {
          r1.value = !r1.value;
        } else {
          r1.value = true;
        }
      } else if (element.dataset.stepNo === '0') {
          r1.value = false;
      }
    };
    const pasos1 = ({ element }: any) => {
      if (element.dataset.stepNo === '2') {
        r1.value = true;
        if (r2.value === true) {
          r2.value = !r2.value;
        }
      } else if (element.dataset.stepNo === '3') {
        r1.value = true;
        r2.value = !r2.value;
        h.value = false;
      } else if (element.dataset.stepNo === '4') {
        h.value = true;
        r2.value = true;
        r3.value = false;
      } else if (element.dataset.stepNo === '6') {
        r1.value = true;
        r2.value = true;
        r3.value = true;
        if (r4.value === true) {
          r4.value = !r4.value;
        }
      } else if (element.dataset.stepNo === '8') {
        r1.value = true;
        r2.value = true;
        r3.value = true;
        r4.value = true;
        if (r5.value === true) {
          r5.value = !r5.value;
        }
      } else if (element.dataset.stepNo === '10') {
        r2.value = true;
        r3.value = true;
        r4.value = true;
        r5.value = true;
      } else if (element.dataset.stepNo === '1') {
        if (r1.value === true) {
          r1.value = !r1.value;
        } else {
          r1.value = true;
        }
      } else if (element.dataset.stepNo === '0') {
          r1.value = false;
      }
    };
    const pasos2 = ({ element }: any) => {
      if (element.dataset.stepNo === '2') {
        r1.value = true;
        if (r2.value === true) {
          r2.value = !r2.value;
        }
      } else if (element.dataset.stepNo === '3') {
        r1.value = true;
        r2.value = !r2.value;
        h.value = false;
      } else if (element.dataset.stepNo === '4') {
        h.value = true;
        r2.value = true;
        r3.value = false;
      } else if (element.dataset.stepNo === '6') {
        r1.value = true;
        r2.value = true;
        r3.value = true;
        if (r4.value === true) {
          r4.value = !r4.value;
        }
      } else if (element.dataset.stepNo === '8') {
        r1.value = true;
        r2.value = true;
        r3.value = true;
        r4.value = true;
        if (r5.value === true) {
          r5.value = !r5.value;
        }
      } else if (element.dataset.stepNo === '10') {
        r2.value = true;
        r3.value = true;
        r4.value = true;
        r5.value = true;
      } else if (element.dataset.stepNo === '1') {
        if (r1.value === true) {
          r1.value = !r1.value;
        } else {
          r1.value = true;
        }
      } else if (element.dataset.stepNo === '0') {
          r1.value = false;
      }
    };
    onMounted(() => {
      setTimeout(() => {
        cargado.value = !cargado.value;
      }, 4800);
      setTimeout(() => {
        toggles.listo = !toggles.listo;
        AOS.init();
      }, 4000);
      if (screen.width <= 500) {
        mov.value = true;
        table.value = false;
      } else if (screen.width <= 800) {
        table.value = true;
        mov.value = false;
      } else {
        mov.value = false;
        table.value = false;
      }
    });
    const toggleForm = () => {
      store.commit('toggleContactForm');
    };
    const toggleMenu = () => {
      toggles.menu = !toggles.menu;
    };
    return {
      toggleMenu,
      contacto,
      toggleForm,
      cargado,
      currStep,
      pasos,
      pasos1,
      pasos2,
      r1,
      r2,
      r3,
      r4,
      r5,
      h,
      mov,
      table,
    };
  },
});
export default new Servicios({
  el: '#servicios',
  vuetify,
  delimiters: ['[{', '}]'],
});
